module.exports = __webpack_public_path__ + "img/bg2.3453c988.png";